webpackJsonp([235131596041995],{

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	__webpack_require__(129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Back = function (_React$Component) {
	  _inherits(Back, _React$Component);
	
	  function Back() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Back);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onItemClick = function () {
	      (0, _gatsbyLink.navigateTo)("/");
	    }, _this.render = function () {
	      var _this2 = _this,
	          onItemClick = _this2.onItemClick;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "navigation" },
	        _react2.default.createElement(
	          "div",
	          { className: "navigation__inner" },
	          _react2.default.createElement(
	            "button",
	            {
	              onClick: onItemClick,
	              className: "navigation__toggle",
	              "aria-controls": "site-navigation",
	              "aria-expanded": "true",
	              "aria-label": "Menu"
	            },
	            _react2.default.createElement(
	              "span",
	              { className: "navigation__hamburger back" },
	              _react2.default.createElement(
	                "span",
	                { className: "navigation__label" },
	                "Home"
	              )
	            )
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Back;
	}(_react2.default.Component);
	
	Back.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        menu: _propTypes2.default.array.isRequired
	      })
	    })
	  })
	};
	
	exports.default = Back;
	module.exports = exports["default"];

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplateDetails = function (_React$Component) {
	  _inherits(PageTemplateDetails, _React$Component);
	
	  function PageTemplateDetails() {
	    _classCallCheck(this, PageTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageTemplateDetails.prototype.render = function render() {
	    var page = this.props.data.markdownRemark;
	
	    return _react2.default.createElement(
	      "div",
	      { className: "content" },
	      _react2.default.createElement(
	        "div",
	        { className: "content__inner" },
	        _react2.default.createElement(
	          "div",
	          { className: "page" },
	          _react2.default.createElement(
	            "h1",
	            { className: "page__title" },
	            page.frontmatter.title
	          ),
	          _react2.default.createElement("div", { className: "page__body", dangerouslySetInnerHTML: { __html: page.html } })
	        )
	      )
	    );
	  };
	
	  return PageTemplateDetails;
	}(_react2.default.Component);
	
	PageTemplateDetails.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.object.isRequired
	  })
	};
	
	exports.default = PageTemplateDetails;
	module.exports = exports["default"];

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Back = __webpack_require__(88);
	
	var _Back2 = _interopRequireDefault(_Back);
	
	var _Sidebar = __webpack_require__(23);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _PageTemplateDetails = __webpack_require__(231);
	
	var _PageTemplateDetails2 = _interopRequireDefault(_PageTemplateDetails);
	
	__webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTemplate = function (_React$Component) {
	  _inherits(PageTemplate, _React$Component);
	
	  function PageTemplate() {
	    _classCallCheck(this, PageTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageTemplate.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	
	    var page = this.props.data.markdownRemark;
	
	    var description = void 0;
	    if (page.frontmatter.description !== null) {
	      description = page.frontmatter.description;
	    } else {
	      description = subtitle;
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: "layout" },
	      _react2.default.createElement(
	        "div",
	        { className: "layout__inner" },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement(
	            "title",
	            null,
	            page.frontmatter.title + " - " + title
	          ),
	          _react2.default.createElement("meta", { name: "description", content: description })
	        ),
	        _react2.default.createElement(_Back2.default, null),
	        _react2.default.createElement(_PageTemplateDetails2.default, this.props),
	        _react2.default.createElement(_Sidebar2.default, this.props)
	      )
	    );
	  };
	
	  return PageTemplate;
	}(_react2.default.Component);
	
	PageTemplate.propTypes = {
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string.isRequired,
	        subtitle: _propTypes2.default.string.isRequired
	      })
	    }),
	    markdownRemark: _propTypes2.default.object.isRequired
	  })
	};
	
	exports.default = PageTemplate;
	
	//eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-template-js-e8163ee780cab4142922.js